import { RoutesPlannerTask } from '@bringg-frontend/routes-planner';
import { ApplicationUuid, PrivilegeTypes } from '@bringg/types';

import { useStores } from 'bringg-web/recipes';
import { assignDriverValidator } from 'bringg-web/services/tasks/assign-driver-validator';
import { useHasFeatureFlag } from 'bringg-web/utils/feature-flags';
import { useHasAccess } from 'bringg-web/utils/privileges';

function useCreateRoutesPlannedModalData() {
	const { applicationStore, merchantConfigurationsStore } = useStores();

	const allowAssignDriverToTask = useHasAccess(PrivilegeTypes.ASSIGN_DRIVER_TO_TASK);

	const userHasAssignRunModalFF = useHasFeatureFlag('assign_run_modal');

	const canOpenPlannedRunsUserAssigner = () => {
		return (
			userHasAssignRunModalFF &&
			(merchantConfigurationsStore.configuration.enable_planned_routes ||
				applicationStore.getApplication(ApplicationUuid.RouteOptimizer2))
		);
	};

	const isRouteAssignAllowed = (tasks: RoutesPlannerTask[], disableAssignDriver?: boolean): boolean => {
		if (disableAssignDriver) {
			return false;
		}
		return (
			canOpenPlannedRunsUserAssigner() &&
			assignDriverValidator.isAllowedToAssignSelectedTasks(tasks, allowAssignDriverToTask).canAssign
		);
	};

	return {
		isRouteAssignAllowed
	};
}

export default useCreateRoutesPlannedModalData;
